import * as React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql} from "gatsby";
import Header from "../components/header";
import Footer from "../components/footer";
import "./layout.css";
import "../styles/global-styles.css";
import "../styles/form.css";
import { Helmet } from "react-helmet";
 

const Layout = ({ children }) => {  
  const data = useStaticQuery(graphql` 
    query SiteTitleQuery {  
      site {
        siteMetadata {  
          title
        }
      }
    }
  `)  

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <div id="bodywrapper">
        <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
        <main className="scroller">{children}</main>
        <Footer />
        <section className="popup-form clearfix">
          <div className="form-warp">
            <h1>Contact Us</h1>
            <div className="contact-form">
              <form
                name="contact"
                method="POST"
                action="/thank-you"
                netlify-honeypot="bot-field"
                data-netlify="true"
              >
                <input type="hidden" name="form-name" value="contact" />
                <form-group>
                  <label for="firstname" htmlFor={"firstname"}>
                    First Name:<sup>*</sup>
                  </label>
                  <input
                    type="text"
                    name="contact-firstname"
                    id="firstname"
                    required
                  />
                </form-group>
                <form-group>
                  <label for="lastname" htmlFor={"lastname"}>
                    Last Name:<sup>*</sup>
                  </label>
                  <input
                    type="text"
                    name="contact-lastname"
                    id="lastname"
                    required
                  />
                </form-group>
                <form-group>
                  <label for="jobtitle" htmlFor={"jobtitle"}>
                    Job Title:<sup>*</sup>
                  </label>
                  <input
                    type="text"
                    name="contact-jobtitle"
                    id="jobtitle"
                    required
                  />
                </form-group>
                <form-group>
                  <label for="phone" htmlFor={"phone"}>
                    Phone:<sup>*</sup>
                  </label>
                  <input type="text" name="contact-phone" id="phone" required />
                </form-group>
                <form-group>
                  <label for="femail" htmlFor={"email"}>
                    Email:<sup>*</sup>
                  </label>
                  <input
                    type="email"
                    name="contact-email"
                    id="email"
                    required
                  />
                </form-group>
                <form-group>
                  <label for="company" htmlFor={"company"}>
                    Company:<sup>*</sup>
                  </label>
                  <input
                    type="text"
                    name="contact-company"
                    id="company"
                    required
                  />
                </form-group>
                <form-group>
                  <label for="website" htmlFor={"firswebsitetname"}>
                    Website:<sup>*</sup>
                  </label>
                  <input
                    type="text"
                    name="contact-firswebsitetname"
                    id="firswebsitetname"
                    required
                  />
                </form-group>
                <form-group class="condition">
                  <input type="checkbox" />
                  <label>
                    I’d like to receive emails from Position<sup>2</sup> which
                    include marketing materials, newsletters, and other related
                    marketing contents. See our{" "}
                    <a href="https://www.position2.com/terms-of-service/">
                      terms of service
                    </a>
                    .
                  </label>
                </form-group>
                <form-group class="condition">
                  <input type="checkbox" />
                  <label>
                    I allow Position<sup>2</sup> to access the above information
                    to contact me by email or by phone.*
                  </label>
                </form-group>
                <input
                  type="submit"
                  name="submit"
                  value="Submit"
                  class="form-button"
                />
              </form>
            </div>
          </div>
          <span className="closebtn"></span>
        </section>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout